import { createFileRoute } from '@tanstack/react-router'
import { SignIn } from '@clerk/clerk-react'

export const Route = createFileRoute('/(auth)/sign-in')({
  component: () => (
    <div className='flex min-h-screen items-center justify-center'>
      <SignIn redirectUrl='/' />
    </div>
  ),
})
